<div *ngIf="photographies?.photographs" class="row">
  <ng-container *ngFor="let index of fixedIndexes">
    <div
      class="col-md-4 mb-4 d-flex flex-column align-items-center justify-content-center"
    >
      <p-photo-miniature
        [imageUrl]="getPhotoByIndex(index) ? getPhotoByIndex(index) : ''"
        class="mb-2"
      ></p-photo-miniature>
      <span class="text-center">
        {{ getTitleByIndex(index) || "-" }}
      </span>
    </div>
  </ng-container>
</div>
